import { render, staticRenderFns } from "./indusdt.vue?vue&type=template&id=2d32a20e"
import script from "./indusdt.vue?vue&type=script&lang=ts"
export * from "./indusdt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports